import React, { ChangeEvent, useState } from 'react';
import { track, isValidEmail, client, consoleLogInDev } from 'shared';
import { useUserContext } from 'UserContext';
import { PastProvider } from './models';
import { getCopy, getOneTimeGiftCardCopy } from './referralCopy';
import ReferralMethod from './ReferralMethod';
import { trackReferralEngagement } from 'api/UserApi';
import { useLocation } from 'react-router-dom';
import { FamilyUserAttributes } from 'parent-portal/shared/UserAttributes';
import userAttributesApi from 'shared/UserAttributesApi';

const ReferralEmail = ({
    referredProvider,
    message,
    referralContext,
    promo,
    setPromoStep,
}: {
    referredProvider: PastProvider;
    message: string;
    referralContext: string;
    promo?: string;
    setPromoStep?: (x: string) => void;
}) => {
    const [buttonText, setButtonText] = useState('Send');
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const { user } = useUserContext();
    const location = useLocation();

    const changeEmail = (e: ChangeEvent<{ value: string }>) => {
        setButtonText('Send');
        setEmail(e.target.value);
    };

    const trackAndSendEmail = () => {
        setLoading(true);
        if (user) {
            trackReferralEngagement(user.id, location.pathname, referralContext)
                .then((response) => response.id)
                .catch(consoleLogInDev)
                .then(sendEmail)
                .catch(consoleLogInDev)
                .finally(() => {
                    setLoading(false);
                    setButtonText('Sent!');
                    if (!!setPromoStep) {
                        setPromoStep('success');
                    }
                    if (!!promo && promo === 'OneTimeGiftCard') {
                        userAttributesApi.create(FamilyUserAttributes.OneTimeGiftCardSent);
                    }
                });
        }
        track('Referrals: Shared via Email', { email, sitter: referredProvider });
    };

    function sendEmail(reid?: number) {
        const url =
            promo === 'OneTimeGiftCard'
                ? 'tracking/api/referral/send-gift-card/?email=True'
                : 'tracking/api/referral/send/?email=True';
        const body = {
            email,
            sitter: referredProvider?.id > 0 ? referredProvider.id : null,
            message,
            default: message === getCopy(referredProvider) || message === getOneTimeGiftCardCopy(),
            reid: !!reid ? reid : null,
        };

        return client(url, {
            body,
        });
    }

    return (
        <ReferralMethod
            buttonText={buttonText}
            action={trackAndSendEmail}
            buttonProps={{ disabled: !isValidEmail(email) }}
            inputProps={{
                placeholder: "your@friend's.email",
                onChange: changeEmail,
                error: !isValidEmail(email),
                helperText: email && !isValidEmail(email) ? 'Please enter a valid email address.' : '',
            }}
            loading={loading}
        />
    );
};

export default ReferralEmail;
